// Module
var code = "<script>let $ctrl</script> <organism-wizard-confirm-view service-wizard-confirm=\"$ctrl.managedServerProjectWizardConfirmation\" wizard-create-object-list=\"$ctrl.wizardCreateObjectList\"></organism-wizard-confirm-view> ";
// Exports
module.exports = code;